import { Component, Input } from '@angular/core';
import { Library } from '../../types/library';
import { CommonModule } from '@angular/common';
import { RouterLink } from "@angular/router";
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-libraries-card',
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './libraries-card.html',
  styleUrl: './libraries-card.scss',
})
export class LibrariesCard {
  @Input() library?: Library;

  get imgURL(): string {
    if (this.library && this.library.imageUrl) {
      if (this.library.imageUrl.startsWith('http')) {
        return this.library.imageUrl;
      }
      return environment.baseUrl + '/Files/' + this.library.imageUrl;
    }
    return 'https://t4.ftcdn.net/jpg/05/16/20/91/360_F_516209113_csr6sPNh8aBrsx8prnluIE1Jxk8fCkld.jpg';
  }
}
